export default {
  Pending: { label: 'Pending',},
  Approved: { label: 'Approved By'},
  Reject: { label: 'Rejected By'},
  Hold: { label: 'Hold By'}
};
